import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import SimpleBar from "simplebar-react";
import { resetListNotificationHeader } from "store/actions";

const NotificationDropdown = props => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["notificationManagement"]);
  const { addToast } = useToasts();

  const notificationManagement = useSelector(
    state => state.notificationManagement
  );
  const {
    loadingListHeader,
    errorListHeader,
    listHeader: notificationHeaderList,
  } = notificationManagement;

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [countBadge, setCountBadge] = useState(0);

  // Action First In
  useEffect(() => {
    notificationHeaderList.params.limit = 10;
    // dispatch(listNotificationHeader(notificationHeaderList.params));
    return () => {
      dispatch(resetListNotificationHeader());
      setCountBadge(0);
    };
  }, [dispatch]);

  // Action Dispatch
  useEffect(() => {
    if (notificationHeaderList && notificationHeaderList.success) {
      if (notificationHeaderList.items.length > 0) {
        setCountBadge(notificationHeaderList.items.length);
      }
    }
  }, [notificationHeaderList]);

  // Error Dispatch
  useEffect(() => {
    if (errorListHeader && errorListHeader.message) {
      addToast(errorListHeader.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListNotificationHeader());
    }
  }, [addToast, dispatch, errorListHeader]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          {countBadge && countBadge > 0 ? (
            <React.Fragment>
              <i className="bx bx-bell bx-tada" />
              <span className="badge bg-danger rounded-pill">{countBadge}</span>
            </React.Fragment>
          ) : (
            <i className="bx bx-bell" />
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">
                  {/* {t("notification")} */}
                  Thông báo
                </h6>
              </Col>
              <div className="col-auto">
                <Link
                  // to="/notification-management/list"
                  to="#"
                  className="small"
                >
                  {/* {t("view_all")} */}
                  Xem tất cả
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {loadingListHeader ? (
              <LoadingFormNormal
                countInput="4"
                countButton="0"
                formClass="row-cols-1"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            ) : (
              <React.Fragment>
                {notificationHeaderList &&
                notificationHeaderList.items.length > 0 ? (
                  <React.Fragment>
                    {notificationHeaderList.items.map(item => {
                      let dtMakerDate = "";
                      let linkNotification = "#";

                      if (item.maker_date) {
                        dtMakerDate = new Intl.DateTimeFormat("en-GB", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                          hour: "2-digit",
                          minute: "2-digit",
                        }).format(Number(item.maker_date) * 1000);
                      }

                      if (
                        item.case_docsign_id &&
                        item.caseDocsign &&
                        item.caseDocsign !== undefined
                      ) {
                        switch (item.caseDocsign.status) {
                          // case STATUS_WAIT_APPROVE:
                          //   linkNotification = `/edocument-management/wait-process`;
                          //   break;
                          // case STATUS_WAIT_A_SIGN:
                          // case STATUS_WAIT_B_SIGN:
                          //   linkNotification = `/edocument-management/in-process`;
                          //   break;
                          // case STATUS_REJECT_APPROVE:
                          // case STATUS_REJECT_SIGN:
                          //   linkNotification = `/edocument-management/deny-sign-approval`;
                          //   break;
                          // case STATUS_COMPLETED:
                          //   linkNotification = `/edocument-management/completed-approval`;
                          //   break;
                          default:
                            linkNotification = `/edocument-management/all?caseDocsignId=${item.case_docsign_id}`;
                            break;
                        }
                      } else {
                        linkNotification = `/notification-management/list?notificationHeaderId=${item.id}&notificationHeaderCode=${item.code}`;
                      }

                      return (
                        <Link
                          key={item.id}
                          to={linkNotification}
                          className="text-reset notification-item"
                        >
                          <div className="media">
                            <div className="avatar-xs me-3">
                              <span className="avatar-title bg-primary rounded-circle font-size-16">
                                <i className="fas fa-file-contract"></i>
                              </span>
                            </div>
                            <div className="media-body">
                              <h6 className="mt-0 mb-1">{item.code}</h6>
                              <div className="font-size-12 text-muted">
                                {dtMakerDate && (
                                  <p className="mb-0">
                                    <i className="mdi mdi-clock-outline" />{" "}
                                    {dtMakerDate}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                    {/* <Link to="" className="text-reset notification-item">
                      <div className="media">
                        <div className="avatar-xs me-3">
                          <span className="avatar-title bg-primary rounded-circle font-size-16">
                            <i className="fas fa-file-contract"></i>
                          </span>
                        </div>
                        <div className="media-body">
                          <h6 className="mt-0 mb-1">
                            {t("Your order is placed")}
                          </h6>
                          <div className="font-size-12 text-muted">
                            <p className="mb-1">
                              {t("If several languages coalesce the grammar")}
                            </p>
                            <p className="mb-0">
                              <i className="mdi mdi-clock-outline" />{" "}
                              {t("3 min ago")}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Link> */}
                  </React.Fragment>
                ) : (
                  <div className="card">
                    <div className="card-body text-center">
                      Không có thông báo mới
                    </div>
                  </div>
                )}
              </React.Fragment>
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              //   to="/notification-management/list"
              to="#"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              {/* {t("view_all")} */}
              Xem tất cả
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
